/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { HealthResponse } from '../models/health-response';
import { MachineLearningResponse } from '../models/machine-learning-response';

@Injectable({
  providedIn: 'root',
})
export class IikigaiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation predictGetDataApiV1SensorsGet
   */
  static readonly PredictGetDataApiV1SensorsGetPath = '/api/v1/sensors';

  /**
   * Predict:Get-Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `predictGetDataApiV1SensorsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  predictGetDataApiV1SensorsGet$Response(params?: {
    data_input?: any;
  }): Observable<StrictHttpResponse<MachineLearningResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IikigaiService.PredictGetDataApiV1SensorsGetPath, 'get');
    if (params) {
      rb.query('data_input', params.data_input, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MachineLearningResponse>;
      })
    );
  }

  /**
   * Predict:Get-Data.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `predictGetDataApiV1SensorsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  predictGetDataApiV1SensorsGet(params?: {
    data_input?: any;
  }): Observable<MachineLearningResponse> {

    return this.predictGetDataApiV1SensorsGet$Response(params).pipe(
      map((r: StrictHttpResponse<MachineLearningResponse>) => r.body as MachineLearningResponse)
    );
  }

  /**
   * Path part for operation predictGetDataApiV1PredictGet
   */
  static readonly PredictGetDataApiV1PredictGetPath = '/api/v1/predict';

  /**
   * Predict:Get-Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `predictGetDataApiV1PredictGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  predictGetDataApiV1PredictGet$Response(params?: {
    data_input?: any;
  }): Observable<StrictHttpResponse<MachineLearningResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IikigaiService.PredictGetDataApiV1PredictGetPath, 'get');
    if (params) {
      rb.query('data_input', params.data_input, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MachineLearningResponse>;
      })
    );
  }

  /**
   * Predict:Get-Data.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `predictGetDataApiV1PredictGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  predictGetDataApiV1PredictGet(params?: {
    data_input?: any;
  }): Observable<MachineLearningResponse> {

    return this.predictGetDataApiV1PredictGet$Response(params).pipe(
      map((r: StrictHttpResponse<MachineLearningResponse>) => r.body as MachineLearningResponse)
    );
  }

  /**
   * Path part for operation healthGetDataApiV1HealthGet
   */
  static readonly HealthGetDataApiV1HealthGetPath = '/api/v1/health';

  /**
   * Health:Get-Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `healthGetDataApiV1HealthGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  healthGetDataApiV1HealthGet$Response(params?: {
  }): Observable<StrictHttpResponse<HealthResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IikigaiService.HealthGetDataApiV1HealthGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HealthResponse>;
      })
    );
  }

  /**
   * Health:Get-Data.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `healthGetDataApiV1HealthGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  healthGetDataApiV1HealthGet(params?: {
  }): Observable<HealthResponse> {

    return this.healthGetDataApiV1HealthGet$Response(params).pipe(
      map((r: StrictHttpResponse<HealthResponse>) => r.body as HealthResponse)
    );
  }

}
